<div class="main-container">
  @if (hasUnfinishedRoom()) {
    <app-countdown-pill
      [timeRemaining]="unfinishedTimeRemaining()"
      [size]="'small'"
      class="time-remaining component-padding"
    />
  } @else {
    <div class="hint-footer">
      <app-notification-hint #hintMessage class="hint-overlay" [messageFetcher]="fetchHints()" />
    </div>
  }

  <div class="footer">
    <app-button
      class="start-button"
      [label]="playButtonLabel()"
      variant="primary"
      stretch="fill"
      (click)="playButtonClicked()"
    />
  </div>
</div>
